import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { ForgotPasswordPage, ResetPasswordPage } from "./components";

export function ForgotPasswordManager() {
  const [email, setEmail] = useState();
  const history = useHistory();

  if (!email) return <ForgotPasswordPage onDone={setEmail} />;

  return (
    <ResetPasswordPage
      email={email}
      onDone={() => {
        history.push("/v2/login");
      }}
    />
  );
}

export default ForgotPasswordManager;
